import React from "react";
import { WidgetTeamScheduleContentList } from "./WidgetTeamScheduleContentList";
import { graphql, useFragment } from "react-relay";
import { WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly$key } from "./__generated__/WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly.graphql";
import { WidgetTeamScheduleContentBaseProps } from "./WidgetTeamScheduleContentBaseProps";
import { AHSeparator, Box } from "arkh";
import { WidgetTeamScheduleContentSectionHeader } from "./WidgetTeamScheduleContentSectionHeader";

export function WidgetTeamScheduleContentMonthly(
  props: WidgetTeamScheduleContentBaseProps & {
    content: WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly$key;
  }
) {
  const content = useFragment(
    graphql`
      fragment WidgetTeamScheduleContentMonthly_WidgetTeamScheduleContentMonthly on WidgetTeamScheduleContentMonthly {
        monthlyTeamSchedule {
          ...WidgetTeamScheduleContentList_teamSchedule
          ...WidgetTeamScheduleContentSectionHeader_teamSchedule
          ...WidgetTeamScheduleContentStatus_teamSchedule
        }
      }
    `,
    props.content
  );

  return (
    <Box style={{ flex: 1 }}>
      <WidgetTeamScheduleContentSectionHeader
        tint={props.tint}
        teamSchedule={content.monthlyTeamSchedule}
      />
      <AHSeparator spaceTop="xsmall" />
      <WidgetTeamScheduleContentList
        tint={props.tint}
        isDarkTint={props.isDarkTint}
        interactive={props.interactive}
        size={props.size}
        teamId={props.teamId}
        teamSchedule={content.monthlyTeamSchedule}
        onPressRoutineOccasion={props.onPressRoutineOccasion}
        mode={props.mode}
        now={props.now}
        idiom={props.idiom}
        onScroll={props.onScroll}
        isFocused={props.isFocused}
      />
    </Box>
  );
}
